import Link from "next/link";
import { ReactNode } from "react";

export function PublicShell({ children }: { children: ReactNode }) {
    return (
        <main className="min-h-screen bg-muted/30">
            <div className="mx-auto flex min-h-screen w-full max-w-6xl flex-col px-4 py-6">
                {children}
                <footer className="mt-auto flex flex-wrap justify-center gap-x-4 gap-y-1 pt-6 text-xs text-muted-foreground">
                    <Link href="/aszf" className="hover:underline">
                        Általános Szerződési Feltételek
                    </Link>
                    <Link href="/adatvedelem" className="hover:underline">
                        Adatkezelési tájékoztató
                    </Link>
                </footer>
            </div>
        </main>
    );
}
